// Utility Functions
const getItem = (orderRow) => ({
    item_id: orderRow?.articleNumber,
    item_name: orderRow?.name,
    discount: orderRow?.campaingPriceValue,
    price: orderRow?.priceValue,
    quantity: orderRow?.quantity,
});
const getOrderTotal = (orderRows) => {
    return orderRows?.reduce((acc, row) => acc + row.priceValue * row.quantity, 0) || 0;
}
const getItems = (orderRows) => orderRows?.map(getItem) || [];

// GTM Tracker Functions
const GtmTracker = () => {
    const dataLayer = window.dataLayer || [];

    const pushEvent = (eventName, ecommerceData, debugMode) => {
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: eventName,
            ecommerce: ecommerceData,
            debug_mode:debugMode
        });
    };

    const pushAddToCartEvent = (cart, articleNumber, quantity) => {
        const foundProduct = cart.orderRows?.find(
            (row) => row.articleNumber === articleNumber.toString()
        );

        const value = (foundProduct?.priceValue - (foundProduct?.campaingPriceValue || 0)) * (quantity || 1);

        pushEvent('add_to_cart', {
            currency: cart?.currencyCode,
            value,
            items: [getItem(foundProduct)],
        }, cart?.debugMode);
    };

    const pushAcceptTerms = (cart) => {
        const items = getItems(cart?.orderRows);

        pushEvent('accept_terms', {
            currency: cart?.currencyCode,
            value: getOrderTotal(cart?.orderRows),
            items,
        }, cart?.debugMode);
    };

    const pushBeginCheckout = (cart) => {
        const items = getItems(cart?.orderRows);

        pushEvent('begin_checkout', {
            currency: cart?.currencyCode,
            value: getOrderTotal(cart?.orderRows),
            items,
        }, cart?.debugMode);
    };

    const pushAddShippingInfo = (cart) => {
        const items = getItems(cart?.orderRows);

        pushEvent('add_shipping_info', {
            currency: cart?.currencyCode,
            value: getOrderTotal(cart?.orderRows),
            shipping_tier: cart?.nShiftOptionName,
            items,
        }, cart?.debugMode);
    };

    const pushAddPaymentInfo = (cart) => {
        const items = getItems(cart?.orderRows);

        pushEvent('add_payment_info', {
            currency: cart?.currencyCode,
            value: getOrderTotal(cart?.orderRows),
            coupon: cart?.coupon,
            items,
        }, cart?.debugMode);
    };

    const purchase = (obj) => {

        pushEvent('purchase', {
            currency: obj?.currency,
            value: obj?.value,
            items: obj.items,
            tax: obj?.tax,
            shipping: obj?.shipping,
            transaction_id: obj?.transaction,
            coupon: obj?.coupon,
        }, obj?.debugMode);
    };

    const viewItem = (obj) => {
        pushEvent('view_item', {
            currency: obj?.currency,
            value: obj?.value,
            items: obj.items,
        },obj?.debugMode);
    };

    return {
        pushAddToCartEvent,
        pushAcceptTerms,
        pushBeginCheckout,
        pushAddShippingInfo,
        pushAddPaymentInfo,
        purchase,
        viewItem,
    };
};

export default GtmTracker;
